import DailyIframe from '@daily-co/daily-js';

export const initializeCallObject = () => {
  const callObject = DailyIframe.getCallInstance();

  if (callObject) {
    return;
  }

  DailyIframe.createCallObject();
};

export const getCallObject = () => {
  const callObject = DailyIframe.getCallInstance();

  if (!callObject) {
    return DailyIframe.createCallObject();
  }

  return callObject;
};
